import { useLocalization } from "./localization"
import { computed } from "vue"

export const usePlaceholders = () => {
    const {isKeLocale} = useLocalization()

    const phoneNumberPlaceholder = computed(() => {
        return isKeLocale.value ? '071 838 1631' : '0803 452 1170'
    })

    const statePlaceholder = computed(() => {
        return isKeLocale.value ? 'Select county' : 'Select State'
    })

    const localtyPlaceholder = computed(() => {
        return isKeLocale.value ? 'Select sub-county' : 'Select LGA'
    })

    return {
        phoneNumberPlaceholder,
        statePlaceholder,
        localtyPlaceholder
    }
}